import { Editor } from '@tiptap/vue-3';

import { TextStyleKit } from '@tiptap/extension-text-style';
import { TableKit } from '@tiptap/extension-table';

import { Focus, Placeholder } from '@tiptap/extensions';
import ImageWithLayout from '@/components/content/tiptap/imageWithLayout';
import TextAlign from '@tiptap/extension-text-align';
import Superscript from '@tiptap/extension-superscript';
import Subscript from '@tiptap/extension-subscript';

import StarterKit from '@tiptap/starter-kit';

import BoundedTableView from '@/components/content/tiptap/BoundedTableView';
import SelectionScopedTextStyle from '@/components/content/tiptap/SelectionScopedTextStyle';
import {
  TableCellBackgroundColor,
  TableHeaderBackgroundColor
} from '@/components/content/tiptap/TableCellBackgroundColor';
import BoundedColumnResize from '@/components/content/tiptap/BoundedColumnResize';

const initTiptapEditor = (options) => {
  const { extensions = [], ...otherOptions } = options;
  return new Editor({
    extensions: [
      StarterKit.configure({
        heading: {
          levels: [1, 2, 3, 4, 5]
        },
        link: {
          protocols: ['http', 'https'],
          openOnClick: false,
          target: '__self'
        }
      }),
      TextStyleKit.configure({
        backgroundColor: {
          types: ['textStyle']
        },
        color: {
          types: ['textStyle']
        },
        fontFamily: {
          types: ['textStyle']
        },
        fontSize: {
          types: ['textStyle']
        },
        lineHeight: {
          types: ['textStyle']
        },
        // the stock `textStyle` mark's `removeEmptyTextStyle` strips the mark from the
        // whole table rather than the selection, so clearing one word's colour cleared every cell.
        // Disabled here and replaced below, the same way the table cells are.
        textStyle: false
      }),
      SelectionScopedTextStyle,
      TextAlign.configure({
        types: ['heading', 'paragraph']
      }),
      TableKit.configure({
        table: {
          resizable: true,
          // Keeps a resized table inside its container instead of letting the column resizer
          // grow it without bound (CSPOL-1959).
          View: BoundedTableView,
          lastColumnResizable: false
        },
        // the stock cell/header nodes have no background attribute, so they are
        // disabled here and replaced below by extended versions that add one. Order matters - the
        // replacements must be registered, or tables lose their cell nodes entirely.
        tableCell: false,
        tableHeader: false
      }),
      TableCellBackgroundColor,
      TableHeaderBackgroundColor,
      ImageWithLayout.configure({ inline: true, allowBase64: true }),
      Placeholder.configure({
        // Use different placeholders depending on the node type:
        placeholder: ({ node }) => {
          if (node.type.name === 'heading') {
            return "What's the heading for this section?";
          }
          return 'Start typing...';
        }
      }),
      Focus,
      Superscript,
      Subscript,
      // Bounds a column drag to its right-hand neighbour so untouched columns keep their width
      // Its own `priority` is what puts it ahead of TableKit's resizer - position in
      // this array has no bearing on it.
      BoundedColumnResize,
      ...extensions
    ],
    ...otherOptions
  });
};

export default initTiptapEditor;
